import { SEARCH_LIST_READ_API_PREFIX } from '@aibees/elephant/constants';
import { HttpMethod } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http';
import { DURATION_MS } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { SearchList } from './types';

export function useReadSearchList(
  id?: string,
  options?: { onlyMyLists?: boolean; enabled?: boolean }
) {
  const workspaceId = useWorkspace()?.id;

  return useBaseQuery<void, SearchList>(
    [useReadSearchList.name, id],
    {
      url: SEARCH_LIST_READ_API_PREFIX.replace(
        ':wid',
        String(workspaceId)
      ).replace(':id', String(id)),
      params: {
        // this excludes the workspace information,
        // for sake of sharing search list with everyone the default is public_info
        return: !options?.onlyMyLists ? 'public_info' : undefined,
      },
      method: HttpMethod.get,
    },
    {
      enabled: options?.enabled && !!id,
      cacheTime: DURATION_MS.days(1),
      staleTime: DURATION_MS.days(1),
    }
  );
}
